/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 * Campaign Page component styles
 *
 * @author Yakov Gushchin
 * @version 1.15.0
 * @since 1.12.0
 */

import styled from 'styled-components';

import { colors } from '../../../../theme';

export const CampaignsPageStyled = styled.div.attrs(({ isSubscriber }: { isSubscriber: boolean }) => ({
    className: `campaign ${isSubscriber ? 'campaign_single' : ''}`,
}))<{ isSubscriber: boolean }>`
    display: grid;
    grid-template-columns: 262px calc(100% - 262px);
    grid-template-rows: min-content;

    height: 100%;
    width: 100%;

    &.campaign_single {
        grid-template-columns: 100%;

        .campaign__content {
            padding-top: 0;
            padding-left: 0;
            border-top: none;
        }
    }

    .campaign__title {
        grid-column-start: 1;
        grid-column-end: 3;
    }

    .campaign__menu {
        .side-menu {
            padding-top: 32px;
            border-top: 1px solid ${colors.borderColorSeparate};
            border-left: none;
            border-bottom: none;
        }
    }

    .campaign__content {
        padding: 32px;
        border-top: 1px solid ${colors.borderColorSeparate};
    }
`;
